export const scheduleKeys = {
  details: () => ['SCHEDULES_DETAIL'] as const, // all single items we visit
  detail: (scheduleId: number | undefined) =>
    [...scheduleKeys.details(), scheduleId] as const, // single item
};
